import { useEffect, useState, useCallback } from 'react';

import useUserData from 'approot/shared/user/user-data';
import { DevEnvNotice } from './header.style';

const HeaderDevNotice = () => {
  const [isDev, setIsDev] = useState<boolean>(true);
  const {
    isSchoolAdmin,
    isAdminOnly,
    isSchoolAccount,
    isInTrial,
  } = useUserData();

  const func = useCallback((e: KeyboardEvent) => {
    if (e.key === '~') {
      setIsDev(false);
    }
  }, []);

  useEffect(() => {
    document.body.addEventListener('keydown', func, false);
    return () => {
      document.body.removeEventListener('keydown', func, false);
    };
    //eslint-disable-next-line
  }, []);

  if (
    process.env.REACT_APP_DEV_NOTICE === 'false' ||
    window.location.host === 'demo.inquisitive.com'
  ) {
    return null;
  }

  return isDev ? (
    <DevEnvNotice>
      Dev ({process.env.REACT_APP_REGION}) ·{' '}
      {isAdminOnly ? 'Admin' : isSchoolAdmin ? 'Teacher/Admin' : 'Teacher'}
      {' · '}
      {isSchoolAccount ? 'School' : 'Individual'}
      {isInTrial ? ' · In Trial' : ''}
    </DevEnvNotice>
  ) : null;
};

export default HeaderDevNotice;
